import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from 'src/environments/environment';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HolidayService {

  private environment = environment.api_endpoint;

  constructor(private http: HttpClient) {
  }

  getHoliday(): Observable<any[]> {
    return this.http.get<any[]>(`${this.environment}/public/special-holiday/list`)
  }
}
